import { useDispatch, useSelector } from "react-redux";
import { getReportes, hideResumen } from "../../app/contaSlice";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { Formik, Form, Field } from 'formik'


export default function ReportsForm({ empresas, url, headers }) {

    const configObj = {
        method: 'get',
        url: url,
        headers: headers,
        params: '',
    }

    const dispatch = useDispatch()

    const handleSubmit = (values) => {

        const range = dateFormatter(values.mmyy)
        const rawParams = {
            Opcion: '',
            FIni: range.startDate,
            FFin: range.endDate,
            IdEmpresa: '',
        }

        if (values.empresa === 'general') {
            rawParams.Opcion = '0'
            delete rawParams.IdEmpresa
        } else {
            rawParams.Opcion = '1'
            rawParams.IdEmpresa = values.empresa
        }

        configObj.params = rawParams
        dispatch(getReportes(configObj))
        dispatch(hideResumen())
    }

    const currentDate = useSelector(state => state.conta.info.FIni)
    const IdEmpresa = useSelector(state => state.conta.info.IdEmpresa)

    return (
        <Formik
            initialValues={{ empresa: (IdEmpresa ? IdEmpresa : 'general'), mmyy: iniDateFormatter(currentDate) }}
            onSubmit={handleSubmit}
        >
            <Form>
                <div className="bg-primarioMira px-4 py-5 shadow rounded-lg sm:p-6">
                    <div className="lg:grid lg:grid-cols-3 lg:gap-6">
                        <div className="lg:col-span-1">
                            <h3 className="text-lg font-medium leading-6 text-white">Filtros</h3>
                            <p className="mt-1 text-sm text-grisMira">Seleccionar empresa y el mes que deseas consultar</p>
                        </div>
                        <div className="mt-5 lg:col-span-2 lg:mt-0">
                            <div className="grid grid-cols-6 gap-6">

                                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                    <label className="block text-sm font-medium text-grisMira">Empresa</label>
                                    <Field name='empresa' as='select' className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm">
                                        <option value='general'>---TODAS LAS EMPRESAS---</option>
                                        {empresas.map((empresa, idx) => <option key={idx} value={empresa.IdEmpresa}>{empresa.Empresa}</option>)}
                                    </Field>
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                    <label className="block text-sm font-medium text-grisMira">
                                        Mes y año
                                    </label>
                                    <Field
                                        type="month"
                                        min='2022-08'
                                        max={currentMMYY()}
                                        name="mmyy"
                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secundario focus:ring-secundario sm:text-sm"
                                    />
                                </div>

                                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                                    <div className="flex justify-end pt-6">
                                        <button
                                            type="submit"
                                            className="w-full ml-3 inline-flex justify-center rounded-md border border-transparent bg-secundario py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-secundario hover:border-2 focus:outline-none focus:ring-1 focus:ring-white focus:ring-offset-2"
                                        >
                                            <div className="flex">
                                                <MagnifyingGlassIcon className="h-5 w-5 text-white" aria-hidden="true" />
                                                <p className="ml-1">Buscar</p>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </Formik>

    )
}

const iniDateFormatter = (yyyymmdd) => {
    //let month, year
    let year = yyyymmdd?.slice(0, 4)
    let month = yyyymmdd?.slice(4, -2)
    if(year !== undefined && month !== undefined){
        return year + '-' + month
    }else{
        month = String(new Date().getMonth() + 1).padStart(2, '0')
        year = String(new Date().getFullYear())
        return year + '-' + month
    }
}


const daysInMonth = (month, year) => {
    return new Date(year, month, 0).getDate()
}

export const dateFormatter = (mmyy) => {
    let month, year, days

    if (mmyy !== '') {
        month = mmyy.slice(-2)
        year = mmyy.slice(0, 4)
        days = String(daysInMonth(month, year))
    } else {
        month = String(new Date().getMonth() + 1).padStart(2, '0')
        year = String(new Date().getFullYear())
        days = String(daysInMonth(month, year))
    }
    return (
        {
            startDate: year + month + '01',
            endDate: year + month + days,
        }
    )
}

export const currentMMYY = () => {
    const d = new Date()
    const year = String(d.getFullYear())
    const month = String(d.getMonth() + 1)
    return year + '-' + month
}

